import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: row;
  ${({ borderWidth }) =>
    borderWidth &&
    `border-width: ${borderWidth};
    border-style: solid;
    border-color: black;`}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ flex }) => flex && `flex: ${flex};`}
`;
